(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["column-content"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.addEventListener('DOMContentLoaded', function() {
      const videoWrappers = document.querySelectorAll('[data-video-wrapper]');

      videoWrappers?.forEach(wrapper => {
        const video = wrapper.querySelector('video');
        const playButton = wrapper.querySelector('[data-video-play-content]');
        const textContent = wrapper.querySelector('[data-text-content]');

        if (!video || !playButton || !textContent) return;

        playButton.addEventListener('click', () => {
          textContent.classList.add('hide');
          video.play();
          video.muted = false;
          video.controls = true;
        });

        video?.addEventListener('ended', () => {
          textContent.classList.remove('hide');
          video.controls = false;
          video.currentTime = 0;
        }, false);

        video.addEventListener('pause', () => {
          textContent.classList.remove('hide');
          video.controls = false;
        }, false);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
